function TaxFactory() {
  class Tax {
    constructor(data) {
      if (data) this.setData(data);
    }

    setData(data) {
      angular.extend(this, data);
    }

    getValue(value) {
      return (this.percentage / 100) * value || 0;
    }

    isNew() {
      return !this._id;
    }
  }

  return Tax;
}

export default TaxFactory;
